import { render, staticRenderFns } from "./djs.vue?vue&type=template&id=77baec22&"
import script from "./djs.vue?vue&type=script&lang=js&"
export * from "./djs.vue?vue&type=script&lang=js&"
import style0 from "./djs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports